import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators'; // Removido o 'retry'
import { AuthService } from './services/auth.service';
import { 
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { AlertModalService } from 'app/shared/alert-modal.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    public authService: AuthService,
    private alertService: AlertModalService,
    private router: Router,
    private ngZone: NgZone
  ) {}

  
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    // Filtra chamadas locais, como a chamada do DataTable para traduzir o contéudo da tabela
    if (request.url.includes('/assets/') || request.url.includes('assets/')) {
      return next.handle(request);
    }
    
    const token = this.authService.getJwtToken();
    if (token) {
      request = this.addToken(request, token);
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // A lógica do Interceptor agora só chama a função de tratamento de erro
        this.handleServerSideError(error);

        // Sempre relança o erro para que os Observables nos serviços/componentes
        // possam ter um tratamento de erro adicional se necessário.
        return throwError(error);
      })
    );
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  private handleServerSideError(error: HttpErrorResponse): void {
    let mensagem: string | undefined;

    if (error.error && error.error.Erros && error.error.Erros.length > 0) mensagem = error.error.Erros[0].Mensagem;

    switch (error.status) {
      case 400:
        // Mensagem de erro genérica para o usuário
        this.alertService.showAlertDanger('Ocorreu um erro na sua requisição. Por favor, verifique os dados.');
        break;
      case 401:
        if (mensagem && mensagem === "Falha ao autenticar") {
          // Situação A: Usuário errou as credenciais na própria tela de login
          this.alertService.showAlertDanger('Credenciais inválidas! Verifique seu usuário e senha e tente novamente.');
        } else {
          // Situação B: O usuário estava navegando e o token expirou no background
          this.alertService.showAlertDanger('Sessão expirada. Por favor, faça login novamente.');
          
          // 1. Captura a URL exata em que o usuário estava antes de ser deslogado
          const currentUrl = this.router.url;

          // 2. Limpa o estado da aplicação pelo AuthService
          this.authService.logout();

          // 3. Redireciona de forma limpa, injetando o returnUrl para a nossa função do LoginComponent funcionar!
          // Nota: Certifique-se de que o método authService.logout() NÃO chame rotas internamente para evitar conflito.
          // this.router.navigate(['/login'], { queryParams: { returnUrl: currentUrl } });
          this.ngZone.run(() => {
            this.router.navigate(['/login'], { queryParams: { returnUrl: currentUrl } });
          });
        }
        break;
        
      case 403:
        this.alertService.showAlertDanger("Você não tem permissão para acessar este recurso.");
        this.router.navigate(['/page-error']);
        break;
      case 404:
        this.alertService.showAlertDanger(mensagem || "O recurso solicitado não foi encontrado.");
        break;
      case 500:
      case 503:
      case 504:
        this.alertService.showAlertDanger("Ocorreu um erro no servidor. Tente novamente mais tarde.");
        break;
      case 0:
        this.alertService.showAlertDanger("Ocorreu um erro de conexão. Verifique sua rede.");
        this.router.navigate(['/page-error']);
        break;
      default:
        this.alertService.showAlertDanger("Ocorreu um problema inesperado!");
        break;
    }
  }
}
